import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import { Duration } from 'constants/duration.constants';
import Prefetcher from 'services/prefetcher';

import ViewInAppContainer from 'components/@app/ViewInAppContainer/ViewInAppContainer';

const ViewInApp: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = () => {
  return <ViewInAppContainer />;
};

export default ViewInApp;

export const getStaticProps = (async ({ locale, preview }) => {
  const prefetcher = await Prefetcher.init({ locale, preview });

  return {
    props: {
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
}) satisfies GetStaticProps;
